module.exports = __webpack_public_path__ + "img/testimonials-bg.33b4be57.jpg";